// extracted by mini-css-extract-plugin
export default {"goldtooth":"ArchivedScriptIcon_goldtooth__T86xR"};